import React, { Component } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  width: 25px;
  height: 25px;
  background-image: ${props => props.image ? 'url(' + props.image + ')' : ''};
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  margin-right: 15px;
  cursor: pointer;
`

class GroupActivityButton extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Container image='/assets/GroupActivity.svg' onClick={this.props.GroupClick} >
      </Container>
    )
  }
}

export default GroupActivityButton



// WEBPACK FOOTER //
// ./src/Components/Activity/GroupActivityButton.jsx